// extracted by mini-css-extract-plugin
module.exports =  {"root":"qVrzKQsnsF7dj2NNVHsv"};